export default __webpack_public_path__ + "static/media/Poppins-SemiBoldItalic.28eeb43d.woff";